import React from 'react'

const ActionButton = () => {
  return (
    <svg width='19' height='18' viewBox='0 0 19 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.35234 12.4922C9.36988 12.5146 9.39229 12.5327 9.41788 12.5452C9.44346 12.5577 9.47154 12.5641 9.5 12.5641C9.52846 12.5641 9.55654 12.5577 9.58212 12.5452C9.60771 12.5327 9.63012 12.5146 9.64766 12.4922L12.2727 9.17109C12.3687 9.04922 12.282 8.86875 12.125 8.86875H10.3883V0.9375C10.3883 0.834375 10.3039 0.75 10.2008 0.75H8.79453C8.69141 0.75 8.60703 0.834375 8.60703 0.9375V8.86641H6.875C6.71797 8.86641 6.63125 9.04688 6.72734 9.16875L9.35234 12.4922ZM18.0781 11.6719H16.6719C16.5688 11.6719 16.4844 11.7563 16.4844 11.8594V15.4688H2.51562V11.8594C2.51562 11.7563 2.43125 11.6719 2.32812 11.6719H0.921875C0.81875 11.6719 0.734375 11.7563 0.734375 11.8594V16.5C0.734375 16.9148 1.06953 17.25 1.48438 17.25H17.5156C17.9305 17.25 18.2656 16.9148 18.2656 16.5V11.8594C18.2656 11.7563 18.1812 11.6719 18.0781 11.6719Z'
        fill='white'
      />
    </svg>
  )
}

export default ActionButton
